import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容",
    links: [
      { label: "视频分类", to: "/video-category" },
      { label: "图片分类", to: "/image-category" },
      { label: "资讯分类", to: "/news-category" },
      { label: "全站搜索", to: "/search" },
    ],
  },
  {
    title: "社区",
    links: [
      { label: "话题列表", to: "/community" },
      { label: "作品讨论", to: "/community" },
      { label: "观影习惯", to: "/community" },
      { label: "创作交流", to: "/community" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容准则", to: "/about" },
      { label: "隐私说明", to: "/about" },
      { label: "意见反馈", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="container-page py-12">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-baseline gap-2">
              <span className="font-heading text-xl font-semibold text-foreground-950">
                成人<span className="text-primary-400">网</span>
              </span>
              <span className="rounded-sm border border-accent-500/60 px-1 py-px text-[10px] text-accent-500">
                18+
              </span>
            </div>
            <p className="mt-3 max-w-xs text-xs leading-relaxed text-foreground-500">
              一个面向成年观众的内容门户：氛围化视频、写真图集、行业资讯与安静的社区讨论。
              站内内容均为演示用途，不提供真实播放与数据存储。
            </p>
            <div className="mt-4 flex items-center gap-2 text-foreground-500">
              <span className="flex h-8 w-8 items-center justify-center rounded-md border border-background-300">
                <i className="ri-mail-line text-sm"></i>
              </span>
              <a
                href="mailto:hello@chengrenwang.demo"
                className="text-xs transition-colors hover:text-accent-500"
              >
                hello@chengrenwang.demo
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-xs font-medium uppercase tracking-[0.2em] text-foreground-600">
                {column.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-xs text-foreground-500 transition-colors hover:text-accent-500"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-[11px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 成人网 · 演示项目，页面内容不构成任何服务承诺。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-500"></i>
            仅限 18 岁以上人士访问 · 适度观看，注意休息
          </p>
        </div>
      </div>
    </footer>
  );
}